export const HTTP_OK = 200;
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;
export const HTTP_INTERNAL_SERVER_ERROR = 500;
export const NOT_ACCEPTABLE = 406;

export const LOGOUT_HTTP_STATUS = [HTTP_UNAUTHORIZED, HTTP_FORBIDDEN];
